import { ColourBox } from './colour';
import { DragAndDrop } from './drag_and_drop';
import { Sortable } from './sortable';
import { Highlight } from './highlight';
import { HTMLTextArea } from './html_text_area';
import { Dialog } from './dialog/dialog';
import { DialogManager } from './dialog/dialog_manager';
import { TreeCombobox } from './tree_combobox/tree_combobox';
import { TreeControl, TreeControlNode } from './tree_control/tree_control';

const dialog = (options) => new Dialog(options);
const dialog_manager = (options) => new DialogManager(options);
const treeComboBox = (options) => new TreeCombobox(options);
const treeControl = (options) => new TreeControl(options);

const control = {
	ColourBox,
	DragAndDrop,
	Sortable,
	Highlight,
	HTMLTextArea,
	dialog,
	dialog_manager,
	treeComboBox, TreeCombobox,
	treeControl, TreeControl, TreeControlNode
	
}

export {
	control, treeComboBox
}